const moment = require('moment');

export const DISPLAY_FORMAT = 'DD.MM.YYYY';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_DISPLAY_FORMAT = 'DD.MM.YYYY HH:mm';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const formatDate = (str, format) =>
    str ? moment(str, DATETIME_FORMAT).format(format || DISPLAY_FORMAT) : '';
